export default __webpack_public_path__ + "static/media/chimney.494af648.jpg";